<div class="table-container" cdkScrollable>
  @if (config().enableSearch || config().enableFilter || config().enableCSVDownload || config().enableExcelDownload) {
    <div class="table-actions-row">
      @if (config().enableSearch) {
        <mat-form-field class="search-field" subscriptSizing="dynamic">
          <mat-label>Filter</mat-label>
          <input matInput (keyup)="applySearch($event)" placeholder="Type to filter..." #input>
        </mat-form-field>
      }
      
      <div class="right-actions">
        @if (config().enableFilter) {
          <button mat-button [color]="activeFilterConfig ? 'accent' : 'primary'" (click)="toggleFilter()">
            <mat-icon>filter_list</mat-icon>
            @if (activeFilterConfig) {
              Filter Active
            } @else {
              Filters
            }
          </button>
          @if (activeFilterConfig) {
            <button mat-button color="warn" (click)="clearFilter()">
              <mat-icon>clear</mat-icon>
              Clear Filter
            </button>
          }
        }
        
        @if (config().enableCSVDownload || config().enableExcelDownload) {
          <button mat-button [matMenuTriggerFor]="downloadMenu">
            <mat-icon>download</mat-icon>
            Download
          </button>
          <mat-menu #downloadMenu="matMenu">
            @if (config().enableExcelDownload) {
              <button mat-menu-item (click)="downloadAsExcel()">
                <mat-icon>description</mat-icon>
                <span>Download Excel</span>
              </button>
            }
            @if (config().enableCSVDownload) {
              <button mat-menu-item (click)="downloadAsCSV()">
                <mat-icon>insert_drive_file</mat-icon>
                <span>Download CSV</span>
              </button>
            }
          </mat-menu>
        }
      </div>
    </div>
  }
  <div class="table-wrapper">
    <table mat-table [dataSource]="dataSource" matSort class="table" multiTemplateDataRows [ngClass]="tableClasses()">
      @if (config().enableRowSelection) {
        <ng-container matColumnDef="select" sticky>
          <th mat-header-cell *matHeaderCellDef>
            @if (config().multipleSelection) {
              <mat-checkbox
                (change)="$event ? toggleAllRows() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"
                [aria-label]="checkboxLabel()">
              </mat-checkbox>
            }
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? onRowSelected(row) : null"
              [checked]="selection.isSelected(row)"
              [aria-label]="checkboxLabel(row)">
            </mat-checkbox>
          </td>
        </ng-container>
      }
  
      @if (config().showSerialNumber) {
        <ng-container matColumnDef="serialNumber" sticky>
          <th mat-header-cell *matHeaderCellDef>S.No</th>
          <td mat-cell *matCellDef="let element;">{{dataIndex(element) + 1}}</td>
        </ng-container>
      }
  
      @for (column of columns(); track column.key) {
        <ng-container [matColumnDef]="column.key" [sticky]="column.sticky">
          <th mat-header-cell *matHeaderCellDef>
            @if (column.sortable) {
              <div [mat-sort-header]="column.key">{{column.header}}</div>
            } @else {
              {{column.header}}
            }
          </th>
  
          <td mat-cell *matCellDef="let element"> 
            @if (column.template) {
              <ng-container [ngTemplateOutlet]="column.template" [ngTemplateOutletContext]="{ $implicit: element }">
              </ng-container>
            } @else {
              @if (isExpandable(element, column.key, column.type)) {
                <button class="expand-button" [ngClass]="{'expanded': isExpanded(element, column.key)}" mat-button (click)="toggleExpand(element, column.key)">
                  Object
                  <mat-icon iconPositionEnd>keyboard_arrow_right</mat-icon>
                </button>
              }
              @else if (column.type === 'boolean') {
                @if (element[column.key]) {
                  <mat-icon class="tick-icon">check_circle</mat-icon>
                } @else {
                  <mat-icon class="cross-icon">cancel</mat-icon>
                }
              }
              @else if (column.type === 'date') {
                {{ element[column.key] | date:'dd/MM/yyyy' }}
              }
              @else {
                {{ element[column.key]}} 
              }
            }
          </td>
        </ng-container>
      }
    
      <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let element" [attr.colspan]="columns().length+1">
          <div class="example-element-detail-wrapper"
            [class.example-element-detail-wrapper-expanded]="isExpanded(element)">
            <div class="example-element-detail">
              @if (expandedElement?.column) {
                <app-json-viewer [json]="expandedElement?.element?.[expandedElement.column]"></app-json-viewer>
              }
            </div>
          </div>
        </td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: config().stickyHeader" class="table-header-bg"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" 
          [ngClass]="{'selectable-row': config().enableRowSelection}"
          (click)="config().enableRowSelection && onRowSelected(row)"
          [class.example-expanded-row]="isExpanded(row)"
          [class.selected-row]="selection.isSelected(row)"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: ['expandedDetail']"
        class="example-detail-row"
      ></tr>
  
      <!-- No data row -->
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell no-data-row" [attr.colspan]="displayedColumns.length > 4 ? 4 : displayedColumns.length">
          No data found
        </td>
      </tr>
    </table>  
  </div>

  @if (config().enablePagination) {
    <mat-paginator 
      [pageSizeOptions]="config().pageSizeOptions || [5, 10, 25, 100]"
      [pageSize]="config().pageSize || 10"
      aria-label="Select page">
    </mat-paginator>
  }
</div>
